import { createSelector } from 'reselect';
import { Cookies } from 'react-cookie';

// SUBJECTS

const getTimeStampStatesBits = state => state.bits.timeStamp;

export const getTimeStampBits = createSelector(
  [getTimeStampStatesBits],
  timeStamp => {
    return timeStamp;
  }
);
const getAllBitsStates = state => state.admin.allBits;

export const getAllBits = createSelector(
  [getAllBitsStates],
  allBits => {
    return allBits;
  }
);

const getBitsUpdatedTodayStates = state => state.bitsUpdateToday;

export const getTodayBits = createSelector(
  [getBitsUpdatedTodayStates],
  bitsUpdateToday => {
    return bitsUpdateToday;
  }
);

const getBits171States = state => state.bits.bits171;

const getBits140States = state => state.bits.bits140;

export const getBits171 = createSelector(
  [getBits171States],
  bits171 => {
    return bits171;
  }
);

export const getBits140 = createSelector(
  [getBits140States],
  bits140 => {
    return bits140;
  }
);
const getEditBitsStates = state => state.bits.editBits;

export const getEditBits = createSelector(
  [getEditBitsStates],
  editBits => {
    return editBits;
  }
);
const getBit1States = state => state.status.changeBit;

export const getBit1 = createSelector(
  [getBit1States],
  change => {
    return change;
  }
);
const getNotificationsState = state => state.notifications.notifications;

export const getNotifications = createSelector(
  [getNotificationsState],
  notifications => {
    return notifications;
  }
);

const getMakesStates = state => state.cddata.makes;

export const getMakes = createSelector(
  [getMakesStates],
  makes => {
    return makes;
  }
);

const getModelsStates = state => state.cddata.models;

export const getModels = createSelector(
  [getModelsStates],
  models => {
    return models;
  }
);

const getVariantsStates = state => state.cddata.variants;

export const getVariants = createSelector(
  [getVariantsStates],
  variants => {
    return variants;
  }
);

const getYearsStates = state => state.cddata.years;

export const getYears = createSelector(
  [getYearsStates],
  years => {
    return years;
  }
);

const getCitiesStates = state => state.cddata.cities;

export const getCities = createSelector(
  [getCitiesStates],
  cities => {
    return cities;
  }
);

const getTimeStampStates = state => state.stock.timeStamp;

export const getTimeStamp = createSelector(
  [getTimeStampStates],
  timeStamp => {
    return timeStamp;
  }
);

const getTimeStampStatesSites = state => state.sites.timeStamp;

export const getTimeStampSites = createSelector(
  [getTimeStampStatesSites],
  timeStamp => {
    return timeStamp;
  }
);
const getTimeStampStatesRigs = state => state.rigs.timeStamp;

export const getTimeStampRigs = createSelector(
  [getTimeStampStatesRigs],
  timeStamp => {
    return timeStamp;
  }
);
const getCustomTimeStates = state => state.stock.customTime;

export const getCustomTime = createSelector(
  [getCustomTimeStates],
  customTime => {
    return customTime;
  }
);

const getMyStockStates = state => state.stock.myStock;

export const getMyStock = createSelector(
  [getMyStockStates],
  myStock => {
    return myStock;
  }
);

const getStockDetailsStates = state => state.stock.stockDetails;

export const getStockDetails = createSelector(
  [getStockDetailsStates],
  stockDetails => {
    return stockDetails;
  }
);

const getStockDetailsIdStates = state => state.stock.stockDetailsId;

export const getStockDetailsId = createSelector(
  [getStockDetailsIdStates],
  stockDetailsId => {
    return stockDetailsId;
  }
);

const getStockDetailsAdminStates = state => state.admin.stockDetails;

export const getStockDetailsAdmin = createSelector(
  [getStockDetailsAdminStates],
  stockDetails => {
    return stockDetails;
  }
);

const getStockBidInfoAdminStates = state => state.admin.biddingInfo;

export const getStockBidInfo = createSelector(
  [getStockBidInfoAdminStates],
  biddingInfo => {
    return biddingInfo;
  }
);

const getStockDetailsIdAdminStates = state => state.admin.stockDetailsId;

export const getStockDetailsIdAdmin = createSelector(
  [getStockDetailsIdAdminStates],
  stockDetailsId => {
    return stockDetailsId;
  }
);

const getFromHistoryAdminStates = state => state.admin.fromHistory;

export const getFromHistoryAdmin = createSelector(
  [getFromHistoryAdminStates],
  fromHistory => {
    return fromHistory;
  }
);

const getApprovedStockStates = state => state.admin.approvedStock;

export const getApprovedStock = createSelector(
  [getApprovedStockStates],
  approvedStock => {
    return approvedStock;
  }
);

const getApprovedStockIdsStates = state => state.admin.approvedStockIds;

export const getApprovedStockIds = createSelector(
  [getApprovedStockIdsStates],
  approvedStockIds => {
    return approvedStockIds;
  }
);

const getAuctionHistoryStockStates = state => state.admin.auctionHistoryStock;

export const getAuctionHistoryStock = createSelector(
  [getAuctionHistoryStockStates],
  auctionHistoryStock => {
    return auctionHistoryStock;
  }
);

const getAllStockStates = state => state.admin.allStock;

export const getAllStock = createSelector(
  [getAllStockStates],
  allStock => {
    return allStock;
  }
);

const getAllSitesStates = state => state.admin.allSites;

export const getAllSites = createSelector(
  [getAllSitesStates],
  allSites => {
    return allSites;
  }
);

const getSitesUpdatedTodayStates = state => state.sitesUpdateToday;

export const getTodaySites = createSelector(
  [getSitesUpdatedTodayStates],
  sitesUpdateToday => {
    return sitesUpdateToday;
  }
);

const getSites171States = state => state.sites.sites171;

const getSites140States = state => state.sites.sites140;

export const getSites171 = createSelector(
  [getSites171States],
  sites171 => {
    return sites171;
  }
);

export const getSites140 = createSelector(
  [getSites140States],
  sites140 => {
    return sites140;
  }
);
const getAllRigsStates = state => state.admin.allRigs;

export const getAllRigs = createSelector(
  [getAllRigsStates],
  allRigs => {
    return allRigs;
  }
);

const getRigsUpdatedTodayStates = state => state.rigsUpdateToday;

export const getTodayRigs = createSelector(
  [getRigsUpdatedTodayStates],
  rigsUpdateToday => {
    return rigsUpdateToday;
  }
);

const getRigs171States = state => state.rigs.rigs171;

const getRigs140States = state => state.rigs.rigs140;

export const getRigs171 = createSelector(
  [getRigs171States],
  rigs171 => {
    return rigs171;
  }
);

export const getRigs140 = createSelector(
  [getRigs140States],
  rigs140 => {
    return rigs140;
  }
);
const getDealStockStates = state => state.admin.dealStock;

export const getDealStock = createSelector(
  [getDealStockStates],
  dealStock => {
    return dealStock;
  }
);

const getAllStockIdsStates = state => state.admin.allStockIds;

export const getAllStockIds = createSelector(
  [getAllStockIdsStates],
  allStockIds => {
    return allStockIds;
  }
);

const getCalendarState = state => state.admin.calendar;

export const getCalendar = createSelector(
  [getCalendarState],
  calendar => {
    return calendar;
  }
);

const getDealDoneStockStates = state => state.stock.dealDoneStock;

export const getDealDoneStock = createSelector(
  [getDealDoneStockStates],
  dealDoneStock => {
    return dealDoneStock;
  }
);

const getAuctionWonStockStates = state => state.stock.wonStock;

export const getAuctionWonStock = createSelector(
  [getAuctionWonStockStates],
  wonStock => {
    return wonStock;
  }
);

const getAuctionLostStockStates = state => state.stock.lostStock;

export const getAuctionLostStock = createSelector(
  [getAuctionLostStockStates],
  lostStock => {
    return lostStock;
  }
);

const getAuctionStockStates = state => state.stock.auctionStock;

export const getAuctionStock = createSelector(
  [getAuctionStockStates],
  auctionStock => {
    return auctionStock;
  }
);

const getAuctionStockIdsStates = state => state.stock.auctionStockIds;

export const getAuctionStockIds = createSelector(
  [getAuctionStockIdsStates],
  auctionStockIds => {
    return auctionStockIds;
  }
);

const getBasketStockStates = state => state.stock.basketStock;

export const getBasketStock = createSelector(
  [getBasketStockStates],
  basketStock => {
    return basketStock;
  }
);

const getBasketStockIdsStates = state => state.stock.basketStockIds;

export const getBasketStockIds = createSelector(
  [getBasketStockIdsStates],
  basketStockIds => {
    return basketStockIds;
  }
);

const getEditStockStates = state => state.stock.editStock;

export const getEditStock = createSelector(
  [getEditStockStates],
  editStock => {
    return editStock;
  }
);

export const getToken = () => {
  const cookies = new Cookies();
  return cookies.get('token');
};

const getEditSitesStates = state => state.sites.editSites;

export const getEditSites = createSelector(
  [getEditSitesStates],
  editSites => {
    return editSites;
  }
);
const getEditRigsStates = state => state.rigs.editRigs;

export const getEditRigs = createSelector(
  [getEditRigsStates],
  editRigs => {
    return editRigs;
  }
);
const getSidebarCollapsedStates = state => state.status.sidebarCollapsed;

export const getSidebarCollapsed = createSelector(
  [getSidebarCollapsedStates],
  collapsed => {
    return collapsed;
  }
);
const getSite1States = state => state.status.changeSite;

export const getSite1 = createSelector(
  [getSite1States],
  change => {
    return change;
  }
);
const getRig1States = state => state.status.changeRRig;

export const getRig1 = createSelector(
  [getRig1States],
  change => {
    return change;
  }
);

const getSerialStates = state => state.status.changeSerial;

export const getSerial = createSelector(
  [getSerialStates],
  change => {
    return change;
  }
);

const getUserState = state => state.user.user;

export const getUser = createSelector(
  [getUserState],
  user => {
    return user;
  }
);

const getAllUserStatesAdmin = state => state.admin.allUsers;

export const getAllUsers = createSelector(
  [getAllUserStatesAdmin],
  allUsers => {
    return allUsers;
  }
);

const getAllManagerStatesAdmin = state => state.admin.allManagers;

export const getAllManagers = createSelector(
  [getAllManagerStatesAdmin],
  allManagers => {
    return allManagers;
  }
);

const getBidDataState = state => state.user.bidData;

export const getBidData = createSelector(
  [getBidDataState],
  bidData => {
    return bidData;
  }
);

export const checkLoggedIn = createSelector(
  [getUserState],
  user => {
    const cookies = new Cookies();
    if (cookies.get('token') && user) {
      return true;
    } else {
      return false;
    }
  }
);

export const checkRemembered = createSelector(
  [getUserState],
  account => {
    const cookies = new Cookies();
    if (cookies.get('remember') === 'true' && account) {
      return true;
    } else {
      return false;
    }
  }
);

// LOCALE
const getLocaleStates = state => state.locale;

export const getLocale = createSelector(
  [getLocaleStates],
  locale => {
    return locale;
  }
);
